export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6451.1dccf58d.jpg";